import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { SpinContainer } from './styles';
const Spin = (props) => {
    const theme = useTheme();
    const { color = theme.colors.purple_1, size = 'medium' } = props;
    return (_jsxs(SpinContainer, { "$color": color, "$size": size, children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }));
};
export default Spin;
